<template>
  <router-link tag="article" :to="url">
    <div class="sys-card">
      <img :src="icon" :alt="title">

      <h2>
        {{ title }}
      </h2>
    </div>
    <!-- /.sys-card -->
  </router-link>
</template>

<script>
  export default {
    name: 'Cards',
    props: {
      title: String,
      icon: String,
      url: String
    }
  };
</script>

<style lang="scss">
  .sys-card {
    padding: 60px 10px;
    margin-bottom: 20px;

    text-align: center;

    background-color: #ffffff;
    border: 1px solid #f1f1f1;
    border-radius: 5px;

    cursor: pointer;

    box-shadow: 0 0 40px -20px #1d2124;

    h2 {
      font-family: 'Lato', sans-serif;
      font-size: 26px;
      line-height: 1.2;
      font-weight: 300;
    }

    img {
      display: inline-block;

      width: 100px;
      height: auto;

      margin-bottom: 15px;
    }
  }

  @media (min-width: 768px) and (max-width: 992px) {
    .sys-card {
      padding: 30px 10px;

      img {
        width: 70px;
      }

      h2 {
        font-size: 24px;
      }
    }
  }
</style>
